import { render, staticRenderFns } from "./TripCategories.vue?vue&type=template&id=db62f7c0&"
import script from "./TripCategories.vue?vue&type=script&lang=js&"
export * from "./TripCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db62f7c0')) {
      api.createRecord('db62f7c0', component.options)
    } else {
      api.reload('db62f7c0', component.options)
    }
    module.hot.accept("./TripCategories.vue?vue&type=template&id=db62f7c0&", function () {
      api.rerender('db62f7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/TripCategories.vue"
export default component.exports